import { Box, Flex, Switch, Text } from '@inflearn/ds-react-next';
import type { ChangeEvent } from 'react';

type Props = {
  onChange: (checked: boolean) => void;
  checked: boolean;
  title: string;
  description: string;
  loading: boolean;
};

export const SettingSwitch = ({ onChange, checked, title, description, loading }: Props) => {
  const handleChangeSwitch = (event: ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.checked);
  };

  return (
    <Flex
      justify="space-between"
      align="center"
      p={24}
      bg="gray.0"
      styles={{
        root: { borderRadius: 10 },
      }}
    >
      <Box mr="md">
        <Text fw={700} fz={16} mb={4}>
          {title}
        </Text>
        <Text
          fz={14}
          c="gray.6"
          styles={{
            root: { whiteSpace: 'pre-line' },
          }}
        >
          {description}
        </Text>
      </Box>
      {loading ? null : (
        <Switch
          checked={checked}
          onChange={handleChangeSwitch}
          size="md"
          aria-label={description}
        />
      )}
    </Flex>
  );
};
